import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models
// ============================================================

export interface FJ781 {
  fj781_01: string;
  fj781_02: number;
  fj781_10: string;  // 項目
  fj781_11: string;  // 規範
  fj781_12: string;  // 承諾數據
  fj781_13: string;  // 允差%
}

export type FoxProChildRow<T extends string> = Record<`${Lowercase<T>}_${string}`, string | number | boolean | null>;
export type FJ782 = FoxProChildRow<'FJ782'>;
export type FJ7821 = FoxProChildRow<'FJ7821'>;
export type FJ7822 = FoxProChildRow<'FJ7822'>;
export type FJ7823 = FoxProChildRow<'FJ7823'>;
export type FJ783 = FoxProChildRow<'FJ783'>;
export type FJ7831 = FoxProChildRow<'FJ7831'>;
export type FJ7832 = FoxProChildRow<'FJ7832'>;
export type FJ7833 = FoxProChildRow<'FJ7833'>;
export type FJ784 = FoxProChildRow<'FJ784'>;
export type FJ785 = FoxProChildRow<'FJ785'>;
export type FJ786 = FoxProChildRow<'FJ786'>;
export type FJ7861 = FoxProChildRow<'FJ7861'>;
export type FJ7862 = FoxProChildRow<'FJ7862'>;
export type FJ7863 = FoxProChildRow<'FJ7863'>;
export type FJ787 = FoxProChildRow<'FJ787'>;
export type FJ7871 = FoxProChildRow<'FJ7871'>;
export type FJ7872 = FoxProChildRow<'FJ7872'>;
export type FJ7873 = FoxProChildRow<'FJ7873'>;
export type FJ788 = FoxProChildRow<'FJ788'>;
export type FJ7881 = FoxProChildRow<'FJ7881'>;
export type FJ7882 = FoxProChildRow<'FJ7882'>;
export type FJ789 = FoxProChildRow<'FJ789'>;

export interface ActiveChildFamilies {
  test_items: FJ781[];
  masterbatches: FJ782[];
  masterbatch_compositions: FJ7821[];
  masterbatch_quotes: FJ7822[];
  masterbatch_processes: FJ7823[];
  yarns: FJ783[];
  yarn_materials: FJ7831[];
  yarn_quotes: FJ7832[];
  yarn_processes: FJ7833[];
  knit_fabrics: FJ784[];
  woven_fabrics: FJ785[];
  finish_knits: FJ786[];
  finish_knit_materials: FJ7861[];
  finish_knit_quotes: FJ7862[];
  finish_knit_processes: FJ7863[];
  finish_wovens: FJ787[];
  finish_woven_materials: FJ7871[];
  finish_woven_quotes: FJ7872[];
  finish_woven_processes: FJ7873[];
  coatings: FJ788[];
  coating_materials: FJ7881[];
  coating_processes: FJ7882[];
  test_reports: FJ789[];
}

export const activeChildFamilyKeys: (keyof ActiveChildFamilies)[] = [
  'test_items', 'masterbatches', 'masterbatch_compositions', 'masterbatch_quotes', 'masterbatch_processes',
  'yarns', 'yarn_materials', 'yarn_quotes', 'yarn_processes', 'knit_fabrics', 'woven_fabrics',
  'finish_knits', 'finish_knit_materials', 'finish_knit_quotes', 'finish_knit_processes',
  'finish_wovens', 'finish_woven_materials', 'finish_woven_quotes', 'finish_woven_processes',
  'coatings', 'coating_materials', 'coating_processes', 'test_reports',
];

export interface FJ780 extends ActiveChildFamilies {
  fj780_01: string;         // 文件編號
  fj780_02: string;         // 色織版號
  fj780_03: string | null;  // 入單日期
  fj780_10: string;         // 產品代號前6碼
  fj780_11: string;         // 產品代號後6碼
  fj780_12: string;         // 產品說明
  fj780_13: string;         // 色號
  fj780_14: string;         // 色名
  fj780_15: number;         // 開發數量
  fj780_16: string;         // 數量單位
  fj780_17: number;         // 單位成本
  fj780_171: string;        // 成本幣別
  fj780_18: string;         // 幣別
  fj780_19: number;         // 可用幅寬(inch)
  fj780_191: number;        // 全幅(inch)
  fj780_192: number;        // 允差%
  fj780_20: number;         // 可用幅寬(cm)
  fj780_201: number;        // 全幅(cm)
  fj780_202: number;        // 允差%(cm)
  fj780_21: number;         // 克重(g/sqm)
  fj780_211: number;        // 克重(g/sqm) 允差
  fj780_22: number;         // 碼重(g/yd)
  fj780_221: number;        // 碼重(g/yd) 允差
  fj780_23: number;         // 經向密度T/INCH
  fj780_24: number;         // 緯向密度T/INCH
  fj780_30: number;         // 測試項目最大序號
  fj780_80: string;         // 狀態 N/P
  fj780_91: string;         // 建立人員
  fj780_92: string | null;  // 建立日期
  fj780_93: string;         // 最後異動人員
}

export interface CreateRequest extends Partial<ActiveChildFamilies> {
  fj780_02?: string;
  fj780_03?: string | null;
  fj780_10: string;
  fj780_11: string;
  fj780_12?: string;
  fj780_13: string;
  fj780_14?: string;
  fj780_15: number;
  fj780_16?: string;
  fj780_17: number;
  fj780_171?: string;
  fj780_18?: string;
  fj780_19?: number;
  fj780_191?: number;
  fj780_192?: number;
  fj780_21?: number;
  fj780_211?: number;
  fj780_22?: number;
  fj780_221?: number;
  fj780_23?: number;
  fj780_24?: number;
}

export interface UpdateRequest extends CreateRequest {
  fj780_80?: string;
}

export interface ApproveRequest {
  fj780_80: string;
}

export interface ListResponse {
  data: FJ780[];
  total: number;
  page: number;
  size: number;
}

export interface ValidationError {
  field: string;
  message: string;
}

export function pickActiveChildFamilies(record: FJ780): ActiveChildFamilies {
  return activeChildFamilyKeys.reduce((payload, key) => {
    (payload[key] as Array<unknown>) = record[key] || [];
    return payload;
  }, {} as ActiveChildFamilies);
}

// ============================================================
// API methods
// ============================================================

export const newProductReportApi = {
  async list(page = 1, size = 100, keyword?: string): Promise<ListResponse> {
    const params: Record<string, string | number> = { page, size };
    if (keyword) params.keyword = keyword;
    const res = await apiClient.get('/api/new-product-report', { params });
    return res.data;
  },

  async get(docNo: string): Promise<FJ780> {
    const res = await apiClient.get(`/api/new-product-report/${encodeURIComponent(docNo)}`);
    return res.data;
  },

  async create(data: CreateRequest): Promise<FJ780> {
    const res = await apiClient.post('/api/new-product-report', data);
    return res.data;
  },

  async update(docNo: string, data: UpdateRequest): Promise<FJ780> {
    const res = await apiClient.put(`/api/new-product-report/${encodeURIComponent(docNo)}`, data);
    return res.data;
  },

  async delete(docNo: string): Promise<void> {
    await apiClient.delete(`/api/new-product-report/${encodeURIComponent(docNo)}`);
  },

  async approve(docNo: string, data: ApproveRequest): Promise<FJ780> {
    const res = await apiClient.patch(`/api/new-product-report/${encodeURIComponent(docNo)}/approve`, data);
    return res.data;
  },
};
